import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../Layout/Scope3Layout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import UpstreamLeased from "./UpstreamLeasedAssets";

const UpstreamLeasedAssets = () => {
  const { user } = useUser();

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <Scope3Layout />}
    >
      <Unauthorized requiredModule="Environment | Scope 3 | Upstream Leased Assets">
        <UpstreamLeased/>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default UpstreamLeasedAssets;

